import React from 'react';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

/**
 * 公共小喇叭音频按钮
 * 统一 PhonicsVocab / PhonicsSound / PhonicsStory 三处的重复定义
 *
 * Props:
 *   playing: boolean — 是否正在播放
 *   onClick: () => void — 点击回调
 *   title: string — 按钮提示文字
 *   size: 'sm' | 'md' — 尺寸，默认 md（30px）；sm 为 24px
 */
function MiniBtn({ playing, onClick, title, size = 'md' }) {
  const iconSize = size === 'sm' ? 14 : 16;
  return (
    <button
      className={`phonics-mini-btn ${playing ? 'playing' : ''}`}
      style={size === 'sm' ? { width: 24, height: 24 } : undefined}
      onClick={onClick}
      title={title}
    >
      <VolumeUpIcon sx={{ fontSize: iconSize }} />
    </button>
  );
}

export default MiniBtn;
